exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".second-stripe{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

